import { Loader2 } from "lucide-react";

import { cn } from "@/lib/cn";

interface EmptyStateAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface EmptyStateProps {
  title: string;
  hint?: string;
  loading?: boolean;
  action?: EmptyStateAction;
}

export function EmptyState({ title, hint, loading, action }: EmptyStateProps) {
  return (
    <div className="panel p-8 text-center">
      {loading ? (
        <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" />
      ) : (
        <>
          <div className="text-sm text-slate-700 font-medium">{title}</div>
          {hint && <div className="text-xs text-slate-500 mt-2">{hint}</div>}
          {action && (
            <button
              type="button"
              onClick={action.onClick}
              disabled={action.disabled}
              className={cn(
                "mt-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors border",
                action.disabled
                  ? "bg-slate-50 text-slate-400 border-slate-200 cursor-not-allowed"
                  : "bg-accent-blue text-white border-accent-blue hover:bg-accent-blue/90"
              )}
            >
              {action.label}
            </button>
          )}
        </>
      )}
    </div>
  );
}
